var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('MenuCuisine'),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"cover"},[_c('MenuLunchBox')],1)]),_c('MenuSeasons',{staticClass:"white",staticStyle:{"padding-top":"100px"}}),_c('MenuSoba',{staticClass:"white2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }